/**
 * Changes the input field of the form
 *
 * @param  {name} name The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
import {
  NEXT_STEP,
  PREV_STEP,
  INITIALISED,
  ADD_STEP,
  TOGGLE_MODAL,
  IN_IT_SLIDER,
  GO_TO_STEP,
  MAKE_ERROR,
  MAKE_DIRTY,
  MAKE_VALID,
  FORM_SAVING,
  VISITED_STEP,
  PROGRESS_INDICATORS,
  INIT_STEPS,
  LENGTH_OF_FILE_NAME,
  CLEAR_STEPS,
  RESET_CURRENT_STEP,
} from './constants';

export function next() {
  return {
    type: NEXT_STEP,
  };
}

export function prev() {
  return {
    type: PREV_STEP,
  };
}

export function goToStep(step, isReview) {
  return {
    type: GO_TO_STEP,
    step,
    isReview,
  };
}

export function initialiseCompleted() {
  return {
    type: INITIALISED,
  };
}

export function addStep(step) {
  return {
    type: ADD_STEP,
    step,
  };
}

export function toggleModalError(errors) {
  return {
    type: TOGGLE_MODAL,
    errors,
  };
}

export function initSlider(slider) {
  return {
    type: IN_IT_SLIDER,
    slider,
  };
}

export function makeError(step) {
  return {
    type: MAKE_ERROR,
    step,
  };
}

export function makeValid(step) {
  return {
    type: MAKE_VALID,
    step,
  };
}

export function makeDirty(step) {
  return {
    type: MAKE_DIRTY,
    step,
  };
}

export function formSaving(status) {
  return {
    type: FORM_SAVING,
    status,
  };
}

export function setVisitedStep(step) {
  return {
    type: VISITED_STEP,
    step,
  };
}

export function setProgressIndicators(indicators) {
  return {
    type: PROGRESS_INDICATORS,
    indicators,
  };
}

export function initWizardSteps(steps) {
  return {
    type: INIT_STEPS,
    steps,
  };
}
export function setInvalidFileName(isInvalid) {
  return {
    type: LENGTH_OF_FILE_NAME,
    isInvalid,
  };
}
export function clearSteps() {
  return {
    type: CLEAR_STEPS,
  };
}
export function resetCurrentStep() {
  return {
    type: RESET_CURRENT_STEP,
  };
}



// WEBPACK FOOTER //
// ./app/containers/Wizard/actions.js